import { createContext } from 'react'

import type { TemplateNode } from '@gymcloud/mixedscript'

/**
 * The template being edited, as the board holds it right now — so a code line can offer the
 * dynamic blocks of this very template beside the saved ones.
 */
export const BoardTemplate = createContext<TemplateNode | null>(null)
